import { render, staticRenderFns } from "./CsoCoreKpi.vue?vue&type=template&id=2b4ead47&scoped=true"
import script from "./CsoCoreKpi.vue?vue&type=script&lang=js"
export * from "./CsoCoreKpi.vue?vue&type=script&lang=js"
import style0 from "./CsoCoreKpi.vue?vue&type=style&index=0&id=2b4ead47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ead47",
  null
  
)

export default component.exports